// extracted by mini-css-extract-plugin
module.exports = {"relatedCasesHeading":"ykvYKBHsFoQZ_G31FEx1k","contactBanner":"SuZxkPW_onqUpiKW29PWM"};